export default __webpack_public_path__ + "static/testimonialCompanyLogo7-64de6585bff68978da22e2386fd581d5.svg";